import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";
// import { DRAWER_WIDTH } from "src/utils/constants";

export const FilterCardStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      padding: "10px 0px",
    },

    preloader: {
      height: "300px",
    },

    subtitleContainer: {
      borderBottom: "1px solid #EAEAEA",
      padding: "15px 22px",
    },

    subtitle: {
      color: "#545454",
      fontSize: "16px",
      linespacing: "19pt",
      fontWeight: 600,
    },

    itemList: {
      padding: "15px 22px",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: theme.palette.primary.contrastText,
      },
    },

    item: {
      fontSize: "20px",
      linespacing: "19pt",
      fontWeight: 600,
    },
  }),
);
